const SEGMENT_LABELS: Record<string, string> = {
    applications: 'Applications',
    capabilities: 'Capabilities',
    workflows: 'Workflows',
    agents: 'Agents',
    models: 'Models',
    prompts: 'Prompts',
    tools: 'Tools',
    skills: 'Skills',
    roles: 'Roles',
    policies: 'Policies',
    decisions: 'Decisions',
    schemas: 'Schemas',
    subscriptions: 'Subscriptions',
    'domain-types': 'Domain Types',
    providers: 'Providers',
    workers: 'Workers',
    settings: 'Settings',
    billing: 'Billing & Payouts',
    'oauth-clients': 'OAuth Clients',
    'api-keys': 'API Keys',
    registries: 'Registries',
    integrations: 'Integrations',
    connections: 'Connections',
    scheduler: 'Scheduler',
    marketplace: 'Marketplace',
    memory: 'Memory',
    bindings: 'Bindings',
    dashboard: 'Dashboard',
    federation: 'Federation Status',
};

/**
 * Derive a simple page title from the URL pathname.
 * Returns the human-readable label for the last meaningful segment,
 * falling back to "Admin" if the pathname is empty or root.
 */
export function getTitleFromRoute(pathname: string): string {
    if (!pathname || pathname === '/') return 'Dashboard';

    const segments = pathname.split('/').filter(Boolean);
    if (segments.length === 0) return 'Dashboard';

    for (let i = segments.length - 1; i >= 0; i--) {
        const label = SEGMENT_LABELS[segments[i]];
        if (label) return label;
    }

    const last = segments[segments.length - 1];
    return last.replace(/[-_]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
